import { RefObject, createContext, useContext } from 'react';

interface StickyContextProps {
  isSticky: boolean;
  stickyBoundaryRef: RefObject<HTMLDivElement> | null;
}

export const StickyContext = createContext<StickyContextProps>({
  isSticky: false,
  stickyBoundaryRef: null,
});

export const useStickyContext = () => {
  return useContext<StickyContextProps>(StickyContext);
};
